function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.477 1.452a1 1 0 01-.813 1.828A8.998 8.998 0 004.16 5.653a8.997 8.997 0 00-.71 10.746 9 9 0 0016.547-4.622l.004-.271v-.93a1 1 0 011.993-.117l.007.117v.93a11 11 0 11-6.524-10.054zm7.23.347a1 1 0 01.084 1.32l-.083.094-11 11a1 1 0 01-1.32.083l-.095-.083-3-3a1 1 0 011.32-1.497l.095.083L11 12.092 21.293 1.799a1 1 0 011.415 0z",
  fill: "currentColor",
  fillRule: "nonzero"
});

var SvgValidate = function SvgValidate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgValidate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/validate.cbac8cae.svg";
export { ForwardRef as ReactComponent };